import React from 'react'
import HomepageCarouselGrid from '@/components/homepage-carousel-grid'
import {HomepageCarouselGridProps} from '@/components/homepage-carousel-grid/types'
import {slidesVisibleValuesDesktop, slidesVisibleValuesMobile} from 'hec/components/ui/carousel'

export const HomepageCarouselGridBuilder = (props: HomepageCarouselGridProps) => {
    return <HomepageCarouselGrid {...props} />
}

export const HomepageCarouselGridBuilderDefinition = {
    component: HomepageCarouselGridBuilder,
    name: 'homepageCarouselGrid',
    noWrap: true,
    inputs: [
        {
            name: 'enableHeroOverlap',
            type: 'boolean',
            defaultValue: false,
            friendlyName: 'Enable Hero Overlap',
            helperText:
                'Enable to allow the carousel grid to overlap with the hero section using negative margin.'
        },
        {
            name: 'productCategory',
            type: 'SFCommerceCategory',
            required: true
        },
        {
            name: 'enableBasicView',
            type: 'boolean',
            defaultValue: true,
            friendlyName: 'Enable Basic View',
            helperText: 'Enable to use the basic view for product tiles in the carousel.'
        },
        {
            name: 'productCarouselHeaderText',
            type: 'string',
            defaultValue: 'Explore More',
            helperText: 'The header text for the product carousel.'
        },
        {
            name: 'resultCount',
            type: 'number',
            defaultValue: 8
        },
        {
            name: 'addedToCartPodId',
            type: 'string',
            required: true
        },
        {name: 'productTileBorderColor', type: 'color'},

        {
            name: 'showNavigationArrows',
            type: 'object',
            friendlyName: 'Show Navigation Arrows',
            subFields: [
                {
                    name: 'onDesktop',
                    type: 'boolean',
                    default: false,
                    helperText: 'Show navigation arrows on desktop'
                },
                {
                    name: 'onMobile',
                    type: 'boolean',
                    default: true,
                    helperText: 'Show navigation arrows on mobile devices'
                }
            ]
        },
        {
            name: 'slidesVisible',
            friendlyName: 'Number of Slides Visible',
            type: 'object',
            subFields: [
                {
                    name: 'onDesktop',
                    type: 'string',
                    enum: slidesVisibleValuesDesktop,
                    defaultValue: '1'
                },
                {
                    name: 'onMobile',
                    type: 'string',
                    enum: slidesVisibleValuesMobile,
                    defaultValue: '2'
                }
            ]
        },
        {
            name: 'showPeek',
            type: 'object',
            friendlyName: 'Show Peek Options',
            subFields: [
                {
                    name: 'onDesktop',
                    type: 'boolean',
                    default: true,
                    helperText: 'Select true to hide peek on desktop'
                },
                {
                    name: 'onMobile',
                    type: 'boolean',
                    default: false,
                    helperText: 'Select true to hide peek on mobile devices'
                }
            ]
        },
        {
            name: 'ButtonNavigationColor',
            type: 'color',
            friendlyName: 'Button Navigation Color',
            helperText: 'Color of the button navigation'
        },
        {
            name: 'slidePadding',
            friendlyName: 'Padding Between Slides',
            type: 'object',
            subFields: [
                {
                    name: 'onDesktop',
                    type: 'string',
                    enum: Array.from({length: 7}, (v, i) => i.toString()),
                    defaultValue: '2',
                    helperText: 'Padding between slides'
                },
                {
                    name: 'onMobile',
                    friendlyName: 'Padding Between Slides Mobile',
                    type: 'string',
                    enum: Array.from({length: 7}, (v, i) => i.toString()),
                    defaultValue: '2',
                    helperText: 'Padding between slides on mobile'
                }
            ]
        },
        {
            name: 'iconsHeaderText',
            type: 'string',
            defaultValue: 'Popular Categories',
            helperText: 'The header text for the icons grid.'
        },
        {
            name: 'items',
            type: 'list',
            subFields: [
                {
                    name: 'image',
                    type: 'file',
                    helperText: 'Image for the item'
                },
                {
                    name: 'external',
                    type: 'boolean',
                    defaultValue: false,
                    helperText: 'Whether the link is external or internal.'
                },
                {
                    name: 'external_link',
                    type: 'reference',
                    model: 'external-links',
                    showIf: `options.get('external') === true`,
                    helperText: 'The external link for the column item.'
                },
                {
                    name: 'link',
                    type: 'reference',
                    model: 'page',
                    showIf: `options.get('external') === false`,
                    helperText: 'The internal link for the column item.'
                },
                {
                    name: 'text',
                    type: 'text',
                    helperText: 'The text for the icon item.'
                }
            ]
        },
        {
            name: 'carouselCtaText',
            type: 'string',
            defaultValue: 'Shop Now',
            helperText: 'The call to action text for the carousel grid.'
        },
        {
            name: 'buttonColor',
            type: 'color',
            helperText: 'The button color for the call to action button.'
        },
        {
            name: 'buttonTextColor',
            type: 'color',
            helperText: 'The text color for the call to action button.'
        },
        {
            name: 'external',
            type: 'boolean',
            defaultValue: false,
            helperText: 'Set to true if the link is external.'
        },
        {
            name: 'link',
            type: 'reference',
            model: 'page',
            showIf: `options.get('external') === false`,
            helperText: 'The internal link for the call to action button.'
        },
        {
            name: 'external_link',
            type: 'reference',
            model: 'external-links',
            showIf: `options.get('external') === true`,
            helperText: 'The external link for the call to action button.'
        },

        {
            name: 'productTileBorderColor',
            type: 'color',
            helperText: 'The border color for the product tiles.'
        }
    ]
}
